"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialSettings = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _settingsWrapper = _interopRequireDefault(require("../../../helpers/settingsWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var initialSettings = exports.initialSettings = {
  imageUrl: '',
  imageFileName: '',
  imageWidth: '10%',
  imageStyle: 'cover'
};
var imageStyleOptions = [{
  value: 'cover',
  label: 'Cover'
}, {
  value: 'tile',
  label: 'Tile'
}];
var localValidate = function localValidate(values) {
  var mainMessage = 'Ask a developer to fix this in the JSON editor.';
  if (!values || !values.imageWidth || !values.imageStyle) {
    return 'Loading initial values...';
  }
  if (!values.imageWidth.endsWith('%')) {
    return "Image Width should end in '%'. " + mainMessage;
  }
  if (!imageStyleOptions.some(function (option) {
    return option.value === values.imageStyle;
  })) {
    return "Image Style should be one of {".concat(imageStyleOptions.map(function (option) {
      return option.value;
    }).toString(), "}. ") + mainMessage;
  }
  return null;
};
var _default = exports["default"] = (0, _settingsWrapper["default"])({
  initialValues: initialSettings
})(function (_ref) {
  var questSettings = _ref.questSettings;
  if (!questSettings || !questSettings.frameStyleSettings) {
    return null;
  }
  var _questSettings$frameS = questSettings.frameStyleSettings,
    imageUrl = _questSettings$frameS.imageUrl,
    imageStyle = _questSettings$frameS.imageStyle,
    imageWidth = _questSettings$frameS.imageWidth,
    imageFileName = _questSettings$frameS.imageFileName;

  // The only errors would happen if someone accidentally edits the JSON editor
  // Handle here instead of via Formik because form might break with incorrect JSON values
  var error = localValidate({
    imageUrl: imageUrl,
    imageStyle: imageStyle,
    imageWidth: imageWidth,
    imageFileName: imageFileName
  });
  if (error) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].settings
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-danger"
    }, error));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].settings
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "imageUrl",
    render: function render(_ref2) {
      var form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
        onChange: function onChange(_ref3) {
          var name = _ref3.name,
            url = _ref3.url;
          form.setFieldValue('imageUrl', url, true);
          form.setFieldValue('imageFileName', name, true);
        },
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-secondary"
        }, imageUrl ? 'Change Image' : 'Upload Image')
      });
    }
  }), imageFileName && /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].fileName
  }, imageFileName)), imageUrl && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].details
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].imageStyle
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "imageStyle",
    component: _cccisdFormik.CccisdSelect,
    options: imageStyleOptions,
    label: "Image Style:"
  })), imageStyle === 'tile' && /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].imageWidth
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "imageWidth",
    render: function render(_ref4) {
      var field = _ref4.field,
        form = _ref4.form;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.CccisdFieldWrapper, {
        field: field,
        form: form,
        label: "Image Width:"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "number",
        className: "form-control",
        id: "imageWidth",
        name: "imageWidth",
        min: "1",
        max: "100",
        step: "1",
        value: imageWidth.substring(0, imageWidth.length - 1),
        onChange: function onChange(event) {
          var width = event.currentTarget.value + '%';
          form.setFieldValue('imageWidth', width, true);
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].percentSign
      }, "%"));
    }
  }))));
});